// src/admin-summary/adminSummaryApi.ts
import { apiClient } from "@maat/api-base";
var adminSummaryApi = {
  getCounts: async () => {
    return apiClient.get("/main/api/admin/summary/counts");
  }
};

export {
  adminSummaryApi
};
